import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const PaymentDetailsContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
`;

export const PaymentDetailsDataContainer = styled.div`
    display: flex;
    width: 100%;
    margin-left: ${({ marginLeft }) => marginLeft? '0px':'0px'};
    // padding: 0 20px;
    ${media.mobileDevice`
        flex-direction: column;
        padding:0;
    `}
`;

export const OrderPaymentContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: 50%;
    margin: ${({ margin }) => (margin ? margin : '0')};
    ${media.mobileDevice`
        width: 100%;
    `}
`;

export const PaymentDetailsFont = styled.p`
    margin: ${({ margin }) => (margin ? margin : '0')};
    font-family: ${({ fontFamily }) =>
        fontFamily ? fontFamily : 'AvenirNextWorld Regular'};
    font-size: ${({ fontSize }) => (fontSize ? fontSize : '15px')};
    letter-spacing: 0px;
    color: #202124;
    opacity: 1;
    line-height: 20px;
`;
// export const RequestInvoiceContainer = styled.div`
//     padding: 0 20px;
// `;